import { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export interface AddressProps {
  city?: string | null;
  street?: string | null;
  postalCode?: string | null;
  countryCode?: string | null;
  divider?: ReactNode;
}

export const Address = ({ countryCode, postalCode, city, street, divider = ', ' }: AddressProps) => {
  const { t } = useTranslation(I18nNamespace.countries);
  const output = [
    // street
    street,
    // zip city
    [postalCode, city].filter(Boolean).join(' '),
    // country countryCode
    countryCode && t(countryCode?.toUpperCase()),
  ].filter(Boolean);

  return (
    <>
      {output.map((item, index) => (
        <Fragment key={index}>
          {index > 0 ? divider : null}
          {item}
        </Fragment>
      ))}
    </>
  );
};
